<app-header></app-header>

<div class="login-container">
  <mat-card class="login-card">
    <mat-card-header>
      <img mat-card-avatar src="assets/client-logo.png" alt="Clinic Logo" class="clinic-logo">
      <mat-card-title class="clinic-name">{{ appConfig.displayName }}</mat-card-title>
      <mat-card-subtitle class="context-info">{{ appConfig.address }}</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <div class="container" *ngIf="!loading">
        <h3>{{ actionMessage }}</h3>
      </div>
      <div class="spinner-container" *ngIf="loading">
        <mat-progress-spinner [diameter]="40" color="primary"></mat-progress-spinner>
        <p>{{ loadingStatus }}</p>
      </div>
    </mat-card-content>
    <mat-card-footer>
      <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
    </mat-card-footer>
  </mat-card>
</div>

<app-footer></app-footer>
